import { AnchorButton, Button } from "@svea/design-system-components-react";
import { FormHelperText, P, Stack, useText } from "@sveabank/cc-common";
import { Link, useNavigate } from "react-router";
import Content from "../../components/content";
import PageNavigationFooter from "../../components/page-navigation-footer";
import { withLoader } from "../../hoc/with-loader";
import { usePageContext } from "../../hooks/context";
import { usePages } from "../../hooks/usePages";
import { useContactForm } from "../contact-info-page/hooks";
import CardSettingItem from "./card-setting-item";
import { useApplicationSettings } from "./hooks";

const ApplicationSettingsPage = () => {
	const navigate = useNavigate();
	const [t, texts] = useText();
	const { cardsToConfigure } = usePageContext(useApplicationSettings);
	const { nextPage, prevPage } = usePages();
	const { hasFormError, setHasFormError } = useContactForm();
	const notCompleted = cardsToConfigure?.find((c) => c.status === "NotCompleted");

	const handleContinue = () => {
		if (notCompleted) {
			setHasFormError(true);
		} else {
			if (!nextPage) throw new Error("Tried navigating to nextPage without nextPage available");
			navigate(nextPage);
		}
	};

	return (
		<Content my={8}>
			<Stack gap={8}>
				<P>{t(texts.applicationSettings.cardSettings.description)}</P>
				<Stack gap={4}>
					{cardsToConfigure.map((card) => (
						<CardSettingItem card={card} key={card.productId} />
					))}
				</Stack>
				<PageNavigationFooter>
					{!notCompleted && (
						<Button onPress={handleContinue} type="submit" form="applicationSettingsForm">
							{t(texts.applicationSettings.buttonText.continue)}
						</Button>
					)}
					{prevPage && (
						<AnchorButton variant="secondary" as={Link} to={prevPage}>
							{t(texts.applicationSettings.buttonText.back)}
						</AnchorButton>
					)}
				</PageNavigationFooter>
				<div className="mt-4 mr-2 flex flex-col items-end">
					{hasFormError && notCompleted && (
						<FormHelperText error align="right">
							{t(texts.applicationSettings.cardSettings.formError)}
						</FormHelperText>
					)}
				</div>
			</Stack>
		</Content>
	);
};

export default withLoader(useApplicationSettings, ApplicationSettingsPage);
